const KEY = 'serviti_signup_business_draft';
const MAX_AGE = 24 * 60 * 60 * 1000;

export function readSignupDraft() {
  try {
    const draft = JSON.parse(sessionStorage.getItem(KEY));
    if (!draft || !Number.isFinite(draft.savedAt) || Date.now() - draft.savedAt > MAX_AGE) return {};
    return {
      businessName: typeof draft.businessName === 'string' ? draft.businessName.slice(0, 100) : '',
      website: typeof draft.website === 'string' ? draft.website.slice(0, 500) : '',
      description: typeof draft.description === 'string' ? draft.description.slice(0, 12000) : '',
      noWebsite: draft.noWebsite === true,
    };
  } catch { return {}; }
}

export function saveSignupDraft({ businessName, website, description, noWebsite }) {
  // No codes, security tokens, consent or personal contact details in storage.
  try { sessionStorage.setItem(KEY, JSON.stringify({ businessName, website, description, noWebsite, savedAt: Date.now() })); } catch { /* Storage is optional. */ }
}

export function clearSignupDraft() {
  try { sessionStorage.removeItem(KEY); } catch { /* Storage is optional. */ }
}
